import { render, staticRenderFns } from "./BillModifyRefund.vue?vue&type=template&id=4dca6adf&scoped=true"
import script from "./BillModifyRefund.vue?vue&type=script&lang=js"
export * from "./BillModifyRefund.vue?vue&type=script&lang=js"
import style0 from "./BillModifyRefund.vue?vue&type=style&index=0&id=4dca6adf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca6adf",
  null
  
)

export default component.exports